module.exports = __webpack_public_path__ + "img/WeiZhu.8f7c9c8b.png";